import { schema } from 'normalizr'

const GroupSchema = new schema.Entity('groups')

export default GroupSchema
